module.exports = __webpack_public_path__ + "img/eth.18708d3e.svg";